<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <span class="navbar-brand">RBAC Roles</span>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <span class="mr-auto">
        @if (canEdit && !userLocked) {
          <button mat-raised-button color="primary" (click)="onSelectRbacRoles()" class="m-1 mr-2">
            <mat-icon>admin_panel_settings</mat-icon> Select RBAC Roles
          </button>
        }

        @if (canEdit && !userLocked) {
          <mat-menu #appMenu="matMenu">
            <button mat-menu-item (click)="dataSource.selectAllToggle()">
              <mat-icon *ngIf="dataSource.isAllSelected()">clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
              {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
            </button>
            <button mat-menu-item (click)="onUnlinkSelectedRbacRoles()" [disabled]="!dataSource.selection.hasValue()">
              <mat-icon>link_off</mat-icon> Unlink Selected
            </button>
          </mat-menu>

          <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect RBAC roles." style="min-width: 120px">
            <mat-icon>more_vert</mat-icon>
            List Menu
          </button>
        }
      </span>

      <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)" *ngIf="canView">
        <input
          class="form-control ml-0 mr-2 my-1"
          type="search"
          [(ngModel)]="dataSource.search"
          name="search"
          placeholder="Search"
          aria-label="Search" />

        <button
          mat-raised-button
          color="secondary"
          type="submit"
          class="mx-0 my-1">
          <mat-icon>search</mat-icon> Search
        </button>
      </form>
    </div>
  </nav>

  <div class="alert alert-warning m-2" *ngIf="!canView">
    <mat-icon class="align-middle mr-2">info</mat-icon>
    You do not have permission to view RBAC roles.
  </div>

  @if (canView && userLocked) {
    <div class="alert alert-info m-2">
      <mat-icon class="align-middle mr-2">lock</mat-icon>
      This {{ utils.getLangTerm('employees.singular', 'Employee').toLowerCase() }}'s roles are managed by {{ utils.getAppName() }}.
    </div>
  }

  <div class="mat-elevation-z8 scroll-box" *ngIf="canView">
    <table mat-table [dataSource]="dataSource" matSort matSortActive="name" matSortDirection="asc" matSortDisableClear>
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
          @if (!userLocked) {
            <mat-checkbox
              (change)="$event ? dataSource.selectAllToggle() : null"
              [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
              [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
            </mat-checkbox>
          }
        </th>
        <td mat-cell *matCellDef="let row">
          @if (!userLocked && !roleLocked(row)) {
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? dataSource.selection.toggle(row.id) : null"
              [checked]="dataSource.selection.isSelected(row.id)">
            </mat-checkbox>
          }
        </td>
      </ng-container>

      <!-- Role Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let element">
          {{ element.name | titlecase }}
        </td>
      </ng-container>

      <!-- Permissions Count Column -->
      <ng-container matColumnDef="rbac_permissions_count">
        <th mat-header-cell *matHeaderCellDef matTooltip="The count of permissions assigned to this role.">
          Permissions
        </th>
        <td mat-cell *matCellDef="let rbac_role">
          <span>
            {{ rbac_role.rbac_permissions_count }}
          </span>
        </td>
      </ng-container>

      <!-- Employees Count Column -->
      <ng-container matColumnDef="users_count">
        <th mat-header-cell *matHeaderCellDef [matTooltip]="'The count of associated ' + utils.getLangTerm('employees.plural', 'Employees').toLowerCase() + '.'">
          {{ utils.getLangTerm('employees.plural', 'Employees') }}
        </th>
        <td mat-cell *matCellDef="let rbac_role">
          <!-- Member names are visible to anyone who can view RBAC roles, matching the account
               roles list. Role membership is governed by the RBAC roles feature, not employees. -->
          <span style="text-decoration: underline;" [matTooltip]="getRbacRoleUsersForTooltip(rbac_role)">
            {{ rbac_role.users_count }}
          </span>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="160"></th>
        <td mat-cell *matCellDef="let element">
          <button type="button" mat-button (click)="onEditRbacRole(element.id)"
            *ngIf="canEdit">
            Edit
          </button>

          @if (canEdit && !userLocked && !roleLocked(element)) {
            <button type="button" mat-button (click)="onUnlinkRbacRole(element.id, $event)">
              Unlink
            </button>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>
  </div>
</div>
